import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { SlackPage } from "../components/slack/SlackPage";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";
import { AdministratorsOnly } from "../components/ui/states";
import { strings } from "../lib/strings";

/** How installing went, as Slack's return to Steer said it. */
const slackSearchSchema = z.object({ slack: z.string().max(40).optional().catch(undefined) });

/** Slack (BUILD_SPEC §18.4), for the workspace's Administrators. */
function SlackRoute() {
  const view = useWorkspace(workspaceSlug());
  const search = useSearch({ from: "/admin/settings/slack" });
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  if (view.data.role !== "administrator") return <AdministratorsOnly what={strings.states.adminPages.slack} />;
  return <SlackPage outcome={search.slack} />;
}

export const Route = createFileRoute("/admin/settings/slack")({
  validateSearch: slackSearchSchema,
  component: SlackRoute,
});
